<template>
  <b-modal
    :id="idModal"
    :ref="idModal"
    size="xl"
    body-classes="p-0"
    @show="cargaModal()"
  >
    <template #modal-header="{ close }">
      <button type="button" aria-label="Close" class="close" @click="close()">
        ×
      </button>
    </template>
    <b-form>
      <div>
        <b-row>
          <b-col>
            <base-input
              type="text"
              label="Nombre y Apellidos"
              placeholder="Nombre y Apellidos"
              v-model="nombre"
              :required="true"
            >
            </base-input>
          </b-col>
          <b-col>
            <base-input
              type="text"
              label="Correo electronico"
              placeholder="Correo electronico"
              v-model="mail"
            >
            </base-input>
          </b-col>
          <b-col style="margin: auto">
            <base-button @click="resetContrasenia"
              >Resetear Contraseña</base-button
            >
          </b-col>
        </b-row>
        <b-row v-if="pass != undefined">
          <b-col>
            <base-input
              label="Nueva Contraseña"
              v-model="pass"
              :disabled="true"
            />
          </b-col>
        </b-row>
      </div>
      <hr class="my-4" />
      <div class="mb-2 ml-4">
        <b-form-group label="Super-Usuario">
          <b-form-radio v-model="privilegios2" :value="1">Si</b-form-radio>
          <b-form-radio v-model="privilegios2" :value="2">no</b-form-radio>
        </b-form-group>
      </div>
      <hr class="my-4" />
      <el-table
        v-if="privilegios2 == 2 && checkDataChange"
        ref="tablaPadre"
        :data="dataCursos"
        style="width: 100%"
        :row-class-name="'warning-row'"
      >
        <el-table-column type="expand">
          <template #default="props">
            <el-table ref="tablaHijo" :data="props.row.grupos">
              <el-table-column label="id" prop="id" />
              <el-table-column label="grupo" prop="grupo" />
              <el-table-column label="privilegios">
                <template #default="scope">
                  <el-checkbox
                    @change="opcionSeleccion(props.row)"
                    size="small"
                    v-model="scope.row.privilegios.lectura"
                    >Lectura</el-checkbox
                  >
                  <el-checkbox
                    @change="opcionSeleccion(props.row)"
                    size="small"
                    v-model="scope.row.privilegios.escritura"
                    >Escritura</el-checkbox
                  >
                </template>
              </el-table-column>
            </el-table>
          </template>
        </el-table-column>
        <el-table-column label="Id" prop="id" />
        <el-table-column label="Curso" prop="curso" />
        <el-table-column label="privilegios">
          <template #default="scope2">
            <el-checkbox
              @change="opcionSeleccionPadre(scope2.row)"
              size="small"
              v-model="scope2.row.privilegios.lectura"
              >Lectura</el-checkbox
            >
            <el-checkbox
              @change="opcionSeleccionPadre(scope2.row)"
              size="small"
              v-model="scope2.row.privilegios.escritura"
              >Escritura</el-checkbox
            >
          </template>
        </el-table-column>
      </el-table>
      <hr class="my-2" />
    </b-form>
    <template #modal-footer>
      <div class="w-100">
        <b-button
          variant="primary"
          size="sm"
          class="float-right"
          @click="guardaUsuario()"
        >
          Guardar
        </b-button>
      </div>
    </template>
  </b-modal>
</template>
<script>
import VueBootstrapTypeahead from "vue-bootstrap-typeahead";
import BaseButton from "../BaseButton.vue";
import swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";

//Spinner
import "@/components/Spinner-Load/loader.css";
import { spinner } from "@/components/Spinner-Load/loader.js";
const loader = spinner();

export default {
  name: "modalCatecumeno",
  components: {
    VueBootstrapTypeahead,
    BaseButton,
  },
  props: ["idModal", "usuario"],
  data() {
    return {
      privilegios2: 2,
      dataCursos: undefined,
      nombre: undefined,
      mail: undefined,
      privilegios: undefined,
      pass: undefined,
    };
  },
  computed:{
    checkDataChange(){
      if(this.$store.getters.getCursosGruposCatequistas != undefined){
        this.cargaCursosGruposCatequistas();
        loader.close();
        return true;
      }else{
        this.$store.dispatch("cargarCursosGruposCatequistas");
        loader.open();
        return false;
      }
    }
  },
  methods: {
    resetContrasenia() {
      swal
        .fire({
          title: `¿Desea resetear la contraseña del usuario ${this.nombre}?`,
          showDenyButton: true,
          showCancelButton: true,
          confirmButtonText: "Cambiar",
          cancelButtonText: `No Cambiar`,
        })
        .then((result) => {
          if (result.isConfirmed) {
            const caracteres =
              "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()_+[]{}|;:,.<>?";
            let contrasena = "";
            for (let i = 0; i < 10; i++) {
              const indiceAleatorio = Math.floor(
                Math.random() * caracteres.length
              );
              contrasena += caracteres.charAt(indiceAleatorio);
            }
            this.pass = contrasena;
          }
        });
    },
    opcionSeleccionPadre(valor) {
      if (valor.privilegios.escritura) {
        valor.grupos.forEach((element) => {
          element.privilegios.escritura = true;
        });
      } else {
        valor.grupos.forEach((element) => {
          element.privilegios.escritura = false;
        });
      }
      if (valor.privilegios.lectura) {
        valor.grupos.forEach((element) => {
          element.privilegios.lectura = true;
        });
      } else {
        valor.grupos.forEach((element) => {
          element.privilegios.lectura = false;
        });
      }
    },
    opcionSeleccion(valor) {
      let longArray = valor.grupos.length;
      let contadorLectura = 0;
      let contadorEscritura = 0;
      valor.grupos.forEach((element) => {
        if (element.privilegios.escritura) {
          contadorEscritura++;
        }
        if (element.privilegios.lectura) {
          contadorLectura++;
        }
      });
      if (contadorEscritura == longArray) {
        valor.privilegios.escritura = true;
      } else {
        valor.privilegios.escritura = false;
      }
      if (contadorLectura == longArray) {
        valor.privilegios.lectura = true;
      } else {
        valor.privilegios.lectura = false;
      }
    },
    cargaModal() {
      if (this.usuario.privilegios == "SU") {
        this.privilegios2 = 1;
      } else {
        this.privilegios2 = 2;
      }
      this.resetDatos();
      this.asignarDatos();
      this.cargaCursosGruposCatequistas();
    },
    asignarDatos() {
      this.nombre = this.usuario.name;
      this.mail = this.usuario.email;
      this.privilegios = this.usuario.privilegios;
      this.pass = undefined;
    },
    resetDatos() {
      this.nombre = undefined;
      this.mail = undefined;
      this.privilegios = undefined;
      this.pass = undefined;
    },
    cargaCursosGruposCatequistas() {
      if(this.usuario){
        this.dataCursos = this.$store.getters.getCursosGruposCatequistas.map(
        (element) => {
          let permisoLectura = false;
          let permisoEscritura = false;
          this.usuario.privilegios.split("/").forEach((elementFor) => {
            if (
              elementFor.split("|")[0] == "C" &&
              elementFor.split("|")[1].split("_")[0] == element.id
            ) {
              if (elementFor.split("|")[1].split("_")[1] == "R") {
                permisoLectura = true;
              } else if (elementFor.split("|")[1].split("_")[1] == "W") {
                permisoEscritura = true;
              }
            }
          });
          return {
            id: element.id,
            curso: element.nombre,
            privilegios: {
              lectura: permisoLectura,
              escritura: permisoEscritura,
            },
            grupos: element.grupos.map((grupo) => {
              let permisoLecturaGrupo = false;
              let permisoEscrituraGrupo = false;
              this.usuario.privilegios.split("/").forEach((elementFor) => {
                if (
                  elementFor.split("|")[0] == "G" &&
                  elementFor.split("|")[1].split("_")[0] == grupo.id
                ) {
                  if (elementFor.split("|")[1].split("_")[1] == "R") {
                    permisoLecturaGrupo = true;
                  } else if (elementFor.split("|")[1].split("_")[1] == "W") {
                    permisoEscrituraGrupo = true;
                  }
                }
              });
              return {
                id: grupo.id,
                grupo: grupo.nombre_grupo,
                privilegios: {
                  lectura: permisoLectura ? true : permisoLecturaGrupo,
                  escritura: permisoEscritura ? true : permisoEscrituraGrupo,
                },
              };
            }),
          };
        });
      }
    },
    guardaUsuario() {
      let privilegios = "";
      if (this.privilegios2 == 1) {
        privilegios = "SU";
      } else {
        this.dataCursos.forEach((element) => {
          if (element.privilegios.escritura) {
            if (privilegios.length > 0) privilegios += "/";
            privilegios += "C|" + element.id + "_W";
          } else if (element.privilegios.lectura) {
            if (privilegios.length > 0) privilegios += "/";
            privilegios += "C|" + element.id + "_R";
          } else {
            element.grupos.forEach((element2) => {
              if (element2.privilegios.escritura) {
                if (privilegios.length > 0) privilegios += "/";
                privilegios += "G|" + element2.id + "_W";
              } else {
                if (element2.privilegios.lectura) {
                  if (privilegios.length > 0) privilegios += "/";
                  privilegios += "G|" + element2.id + "_R";
                }
              }
            });
          }
        });
      }
      if (this.pass != undefined) {
        var nuevoUsuario = {
          email: this.mail,
          name: this.nombre,
          privilegios: privilegios,
          id: this.usuario.id,
          password: this.pass,
        };
        this.$emit("guardaUsuario", nuevoUsuario);
      } else {
        var nuevoUsuario = {
          email: this.mail,
          name: this.nombre,
          privilegios: privilegios,
          id: this.usuario.id,
        };
        this.$emit("guardaUsuario", nuevoUsuario);
      }
    },
  },
};
</script>
<style>
.el-table .warning-row {
  background: antiquewhite;
}
</style>
